var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('md-card',[_c('md-card-header',{staticClass:"md-card-header-icon md-card-header-green"},[_c('div',{staticClass:"card-icon"},[_c('md-icon',{class:_vm.formIconClass},[_vm._v(_vm._s(_vm.formIcon))])],1),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('md-card-content',[_c('ValidationProvider',{attrs:{"name":"status","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var passed = ref.passed;
var failed = ref.failed;
return [_c('md-field',{class:[{ 'md-error': failed }, { 'md-valid': passed }]},[_c('label',[_vm._v("Status")]),_c('md-select',{attrs:{"name":"status","id":"status","required":"","disabled":_vm.requesting},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.statuses),function(status,index){return _c('md-option',{key:index,attrs:{"value":index}},[_vm._v(_vm._s(status.label))])}),1)],1)]}}])}),_c('ValidationProvider',{attrs:{"name":"year","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var passed = ref.passed;
var failed = ref.failed;
return [_c('md-field',{class:[{ 'md-error': failed }, { 'md-valid': passed }]},[_c('label',[_vm._v("Jaar")]),_c('md-select',{attrs:{"name":"year","id":"year","required":"","disabled":_vm.requesting || _vm.disabledForEdit},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}},_vm._l(([
                2022,
                2023,
                2024,
                2025,
                2026,
                2027,
                2028,
                2029,
                2030,
                2031,
                2032,
                2033
              ]),function(yearOption,index){return _c('md-option',{key:index,attrs:{"value":yearOption}},[_vm._v(_vm._s(yearOption))])}),1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],staticClass:"error"},[_vm._v("close")])],1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(passed),expression:"passed"}],staticClass:"success"},[_vm._v("done")])],1)],1)]}}])}),_c('ValidationProvider',{attrs:{"name":"week","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var passed = ref.passed;
              var failed = ref.failed;
return [_c('md-field',{class:[{ 'md-error': failed }, { 'md-valid': passed }]},[_c('label',[_vm._v("Week")]),_c('md-select',{attrs:{"name":"week","id":"week","required":"","disabled":_vm.requesting || _vm.disabledForEdit},model:{value:(_vm.week),callback:function ($$v) {_vm.week=$$v},expression:"week"}},_vm._l(([
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53
              ]),function(weekOption,index){return _c('md-option',{key:index,attrs:{"value":weekOption}},[_vm._v(_vm._s(weekOption))])}),1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],staticClass:"error"},[_vm._v("close")])],1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(passed),expression:"passed"}],staticClass:"success"},[_vm._v("done")])],1)],1)]}}])})],1),_c('md-card-actions',[_c('md-button',{class:{
          'md-primary': !_vm.formOrScheduleTouched,
          'md-warning': _vm.formOrScheduleTouched
        },attrs:{"native-type":"button","disabled":_vm.requesting},nativeOn:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("Terug")]),_c('md-button',{staticClass:"md-success",attrs:{"disabled":!_vm.formOrScheduleTouched || _vm.requesting,"native-type":"submit"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Opslaan")])],1)],1),(this.$route.params.id !== undefined)?_c('schedule-editor',{ref:"scheduleEditor",attrs:{"schedule-id":this.$route.params.id,"data-max-shifts-per-day":_vm.maxShiftsPerDay},on:{"changed":this.scheduleHasChanged,"resetScheduleTouched":this.resetScheduleTouched}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }